"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _clsx2 = _interopRequireDefault(require("clsx"));

var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));

var _makeStyles = _interopRequireDefault(require("@material-ui/styles/makeStyles"));

var _ReactSVGIcon = _interopRequireDefault(require("@micado-digital/react-svg-icon/ReactSVGIcon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var useStyles = (0, _makeStyles.default)(function (theme) {
  return {
    root: {
      alignItems: "center",
      cursor: "pointer",
      display: "flex",
      userSelect: "none"
    },
    label: {
      marginRight: theme === null || theme === void 0 ? void 0 : theme.spacing(0.5)
    },
    rtl: {
      flexDirection: "row-reverse"
    }
  };
});

var Hamburger = function Hamburger(_ref) {
  var _ref$align = _ref.align,
      align = _ref$align === void 0 ? "ltr" : _ref$align,
      click = _ref.click,
      icon = _ref.icon,
      label = _ref.label;
  var css = useStyles();
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx2.default)("menu-01-hamburger", css.root, _defineProperty({}, css.rtl, align === "rtl")),
    onClick: click
  }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
    className: (0, _clsx2.default)("menu-01-hamburger__label", css.label)
  }, label), /*#__PURE__*/_react.default.createElement(_ReactSVGIcon.default, {
    src: icon
  }));
};

Hamburger.propTypes = {
  align: _propTypes.default.string,
  click: _propTypes.default.func.isRequired,
  icon: _propTypes.default.string.isRequired,
  label: _propTypes.default.string
};
var _default = Hamburger;
exports.default = _default;